import React, { ReactElement, useContext, useState } from 'react';
import { AuthContext } from 'context/AuthContext';
import PageLoading from 'components/loading/PageLoading';
import MainSwitch from 'components/mainComponents/RoutesSwitch/MainSwitch';
import './App.scss';

const App: React.FC<{}> = (): ReactElement => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    state: { loading },
  } = useContext(AuthContext);

  const handleDrawerState = (): void => {
    setIsOpen(!isOpen);
  };

  if (loading) return <PageLoading />;

  return (
    <div className='root'>
      <MainSwitch isOpen={isOpen} onClick={handleDrawerState} />
    </div>
  );
};

export default App;
